import axios from 'axios';


class ApiService {
    constructor() {
        this.baseURL = process.env.REACT_APP_API || 'https://tenishevaschool.ru/';
        this.axiosInstance = axios.create({
            baseURL: this.baseURL,
        });
    }

    async getDocs(type) {
        try {
            const response = await this.axiosInstance.get('/api/public/info', {
                params: { docs: type }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching docs:', error);
            throw error;
        }
    }
    getMediaURL (suburl)
    {
        if (suburl) return this.baseURL+suburl
        else return this.baseURL
    }
}

export default new ApiService();